module.exports = __webpack_public_path__ + "static/niti-rib-d918f728dcbced06eafb498d86a84cf4.jpg";